<template>
  <div class="page">
    <van-nav-bar class="nav-bar" :title="$t('详情信息')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
      </template>
    </van-nav-bar>
    <div class="lady-info-wrapper">
      <div class="basic">
        <div class="info">
          <div class="name">{{ ladyInfo.xuanfei_name }}</div>
          <div class="body">{{ $t('身高') }}: {{ ladyInfo.height }} {{ $t('胸围') }}: {{ ladyInfo.chest }}</div>
          <div class="tag">
            <van-tag :key="index" v-for="(tag,index) in tagList" type="primary" size="large">{{ tag }}</van-tag>
          </div>
        </div>
        <div class="thumb">
          <van-image
              @click="thumbClick"
              width="60px"
              height="60px"
              :src="require('@/assets/image/thumb.png')"
          />
          <div class="thumb-num">{{ ladyInfo.like }}</div>
        </div>
      </div>
      <div class="opera">
        <div class="fee">
          <div class="fee-rate">
            <span>{{ $t('服务评分') }}:</span>
            <van-rate
                v-model="ladyInfo.mark"
                :size="18"
                color="#ffd21e"
                void-icon="star"
                readonly
                void-color="#eee"
            />
          </div>
          <div class="location">
            {{ $t('住所') }}:
          </div>
        </div>
        <div class="btn" @click="handleBook">{{ $t('立即预约') }}</div>
      </div>
    </div>

    <div class="media">
      <van-tabs
          v-model="active"
          animated
          title-active-color="#CA3358"
          title-inactive-color="#3634D9"
          :ellipsis="false"
          line-width="40px"
          @change="tabChange"
      >
        <van-tab :title="$t('照片')" name="photo"></van-tab>
        <van-tab :title="$t('视频')" name="video"></van-tab>
      </van-tabs>

      <div class="show-area" v-show="active === 'photo'">
        <van-swipe :loop="false" :width="100" :show-indicators="false">
          <van-swipe-item v-for="(img, index) in ladyInfo.img_url" :key="index">
            <div @click="activePreviewCover = index"
                 :class="activePreviewCover === index ? 'active' : '' "
                 class="img-wrapper">
              <van-image
                  v-dev-placeholder:avatar
                  width="100px"
                  height="100px"
                  :src="img"
              >
                <template v-slot:loading>
                  <van-loading type="circular"/>
                </template>
              </van-image>
            </div>
          </van-swipe-item>
        </van-swipe>
        <div class="preview">
          <van-image
              v-dev-placeholder:cover
              width="100%"
              :src="ladyInfo.img_url?ladyInfo.img_url[activePreviewCover]:null"
          >
            <template v-slot:loading>
              <van-loading type="circular"/>
            </template>
          </van-image>
        </div>
      </div>
      <div v-show="active === 'video'" class="movie-video show-area">
        <video id="my-video" class="video-js"></video>
      </div>
    </div>
    <div class="intro">
      <div class="title">{{ $t('个人简介') }}:</div>
      <div class="content">{{ ladyInfo.description }}</div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";

export default {
  data() {
    return {
      ladyInfo: [],
      active: 'photo',
      activePreviewCover: 0,
      flag: false,
      nowPlayVideoUrl: "",
      cover: "",
      player: null
    };
  },
  computed: {
    tagList() {
      if (!this.ladyInfo.tag) {
        return []
      }
      // 默认英文
      return this.ladyInfo.tag.split('，')
    }
  },
  methods: {
    tabChange(name) {
      if (name === 'video' && this.player == null) {
          this.initVideo();
      }

      if (name === 'photo' && this.nowPlayVideoUrl) {
        this.player.pause()
      }
    },
    initVideo() {
      if (this.player) {
        console.log("Player already initialized, updating source.");
        this.updateVideoSource();
        return;
      }

      this.nowPlayVideoUrl = this.ladyInfo.video;
      this.$nextTick(() => {
        let videos = document.getElementById('my-video');
        if (!videos) {
          console.error("Video element not found.");
          return;
        }
        videos.poster = null;

        this.player = videojs("my-video", {
          height: "200px",
          preload: "auto", // 预加载
          controls: true,  // 显示播放的控件
          multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
        });

        this.player.src([{
          src: this.nowPlayVideoUrl,
          type: this.nowPlayVideoUrl.endsWith('.m3u8') ? "application/x-mpegURL" : "video/mp4"
        }]);

        this.player.on('error', (event) => {
          console.error("Video player error:", event);
        });
      });
    },
    getInfo() {
      this.$http({
        method: 'get',
        url: 'xuanfeidata',
        data: {id: this.$route.query.id}
      }).then(res => {
        this.ladyInfo = res.data;
        console.log("=>(profile.vue:169) this.ladyInfo", this.ladyInfo);
      });
    },
    handleBook() {
      this.$toast(this.$t('请联系顾问或接待员'));
    },
    thumbClick() {
      if (!this.flag) {
        this.ladyInfo.like = Number(this.ladyInfo.like) + 1;
      } else {
        this.ladyInfo.like = Number(this.ladyInfo.like) - 1;
      }
      this.flag = !this.flag;
    },
    updateVideoSource() {
      this.player.src([{
        src: this.nowPlayVideoUrl,
        type: this.nowPlayVideoUrl.endsWith('.m3u8') ? "application/x-mpegURL" : "video/mp4"
      }]);
      this.player.load(); // 加载新源
      this.player.play(); // 开始播放
    },
    destroyPlayer() {
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }
    },
  },
  created() {
    this.getInfo();
  },
  beforeDestroy() {
    this.destroyPlayer(); // 在组件销毁前销毁播放器
  }
};
</script>

<style scoped lang="less">
.lady-info-wrapper {
  color: rgb(107, 34, 179);
  background-color: #fff;
  padding: 30px;
  border-bottom: 30px solid #EBEDF0;

  .basic {
    display: flex;
    justify-content: space-between;

    .info {
      .name {
        color: #2c1868;
        font-size: 32px;
      }

      .body {
        font-size: 21px;
        margin-top: 15px;
      }

      .tag {
        margin-top: 10px;

        .van-tag--large {
          margin-top: 10px;
          padding: 3vw 2.067vw;
          font-size: 3vw;
          border-radius: 2.1vw;
          margin-right: 1.333vw;
          background: linear-gradient(50deg, #9b54ca, #e6557f);

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .thumb {
      text-align: center;
    }
  }

  .opera {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    font-size: 27px;

    .btn {
      color: #fff;
      padding: 2.667vw 4vw;
      background: linear-gradient(20deg, #e73266, #ee5380);
      border-radius: 7vw;
    }
  }
}

.media {
  background-color: #fff;

  ::v-deep .van-tabs--line .van-tabs__wrap {
    height: 80px;
  }

  ::v-deep .van-tabs {
    background-color: #fff;
  }

  ::v-deep .van-tabs__nav {
    padding-left: 30px;
  }

  ::v-deep .van-tab {
    white-space: nowrap;
  }

  ::v-deep .van-tab__text--ellipsis {
    overflow: auto !important;
  }

  ::v-deep .van-tab {
    font-size: 30px;
    flex: 0;
    min-width: 100px;
  }

  ::v-deep .van-swipe {
    padding-top: 20px;
    box-sizing: content-box;
  }

  ::v-deep .van-swipe-item {
    margin-right: 20px;
  }

  .preview {
    padding: 30px;
  }

  .active {
    ::v-deep .van-image {
      border: 8px solid #e54878;
    }
  }

  .img-wrapper {
    position: relative;
    z-index: 2;
    width: 200px;
    height: 200px;
  }

  .video-js {
    width: 100%;
    /*height: 420px;*/
    font-size: 24px;
    margin-top: 20px;
  }

  ::v-deep .movie-video .video-js .vjs-big-play-button {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0;
    margin-left: 0;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    line-height: 80px;
  }
}

.intro {
  background-color: #fff;
  margin-top: 30px;
  padding: 30px 30px 60px 30px;

  .title {
    color: #2a1648;
    font-weight: bold;
  }

  .content {
    margin-top: 20px;
    color: #534589;
  }
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  // 基本信息区域PC端适配
  .lady-info-wrapper {
    padding: 17px; /* 30px * 0.5733 ≈ 17px */
    border-bottom: 17px solid #EBEDF0; /* 30px * 0.5733 ≈ 17px */

    .basic {
      .info {
        .name {
          font-size: 18px; /* 32px * 0.5733 ≈ 18px */
        }

        .body {
          font-size: 12px; /* 21px * 0.5733 ≈ 12px */
          margin-top: 9px; /* 15px * 0.5733 ≈ 9px */
        }

        .tag {
          margin-top: 6px; /* 10px * 0.5733 ≈ 6px */

          .van-tag--large {
            margin-top: 6px; /* 10px * 0.5733 ≈ 6px */
            padding: 11px 9px; /* 3vw * 0.5733 ≈ 11px, 2.067vw * 0.5733 ≈ 9px */
            font-size: 12px; /* 3vw * 0.5733 ≈ 12px */
            border-radius: 9px; /* 2.1vw * 0.5733 ≈ 9px */
            margin-right: 6px; /* 1.333vw * 0.5733 ≈ 6px */
          }
        }
      }

      .thumb {
        ::v-deep .van-image {
          width: 34px !important; /* 60px * 0.5733 ≈ 34px */
          height: 34px !important; /* 60px * 0.5733 ≈ 34px */
        }

        .thumb-num {
          font-size: 14px; /* 假设24px * 0.5733 ≈ 14px */
          margin-top: 3px;
        }
      }
    }

    .opera {
      margin-top: 17px; /* 30px * 0.5733 ≈ 17px */
      font-size: 15px; /* 27px * 0.5733 ≈ 15px */

      .btn {
        padding: 12px 12px; /* 2.667vw * 0.5733 ≈ 8px, 4vw * 0.5733 ≈ 12px */
        border-radius: 25px; /* 7vw * 0.5733 ≈ 16px */
        font-size: 15px; /* 27px * 0.5733 ≈ 15px */
      }

      .fee-rate {
        font-size: 15px; /* 27px * 0.5733 ≈ 15px */
        display: flex;
        align-items: center;
        gap: 5px;
        
        ::v-deep .van-rate {
          font-size: 10px; /* 18px * 0.5733 ≈ 10px */
        }
        
        ::v-deep .van-rate__icon {
          font-size: 10px !important; /* 18px * 0.5733 ≈ 10px */
        }
      }

      .location {
        font-size: 15px; /* 27px * 0.5733 ≈ 15px */
        margin-top: 6px;
      }
    }
  }

  // 媒体区域PC端适配
  .media {
    ::v-deep .van-tabs--line .van-tabs__wrap {
      height: 46px; /* 80px * 0.5733 ≈ 46px */
    }

    ::v-deep .van-tabs__nav {
      padding-left: 17px; /* 30px * 0.5733 ≈ 17px */
    }

    ::v-deep .van-tab {
      white-space: nowrap;
    }

    ::v-deep .van-tab {
      font-size: 17px; /* 30px * 0.5733 ≈ 17px */
      min-width: 57px; /* 100px * 0.5733 ≈ 57px */
    }

    ::v-deep .van-swipe {
      padding-top: 11px; /* 20px * 0.5733 ≈ 11px */
    }

    ::v-deep .van-swipe-item {
      margin-right: 11px; /* 20px * 0.5733 ≈ 11px */
    }

    .preview {
      padding: 17px; /* 30px * 0.5733 ≈ 17px */
    }

    .active {
      ::v-deep .van-image {
        border: 5px solid #e54878; /* 8px * 0.5733 ≈ 5px */
      }
    }

    .img-wrapper {
      width: 115px; /* 200px * 0.5733 ≈ 115px */
      height: 115px; /* 200px * 0.5733 ≈ 115px */
    }

    .video-js {
      font-size: 14px; /* 24px * 0.5733 ≈ 14px */
      margin-top: 11px; /* 20px * 0.5733 ≈ 11px */
    }

    ::v-deep .movie-video .video-js .vjs-big-play-button {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-top: 0;
      margin-left: 0;
      width: 46px; /* 80px * 0.5733 ≈ 46px */
      height: 46px; /* 80px * 0.5733 ≈ 46px */
      border-radius: 50%;
      line-height: 46px;
    }
  }

  // 简介区域PC端适配
  .intro {
    margin-top: 17px; /* 30px * 0.5733 ≈ 17px */
    padding: 17px; /* 30px * 0.5733 ≈ 17px */
    padding-bottom: 34px; /* 60px * 0.5733 ≈ 34px */

    .title {
      font-size: 18px; /* 假设32px * 0.5733 ≈ 18px */
    }

    .content {
      margin-top: 11px; /* 20px * 0.5733 ≈ 11px */
      font-size: 14px; /* 假设24px * 0.5733 ≈ 14px */
    }
  }
}
</style>
